(() => {
  const MAP_URL = 'https://www.google.com/maps/search/?api=1&query=Av.%20Pedro%20de%20Valdivia%201783%2C%20Providencia%2C%20Chile';

  function addHomeAddress() {
    const facts = document.querySelector('.lp3-pickup-card__facts');
    if (!facts || facts.querySelector('.lp3-pickup-card__fact--address')) return;

    const address = document.createElement('a');
    address.className = 'lp3-pickup-card__fact lp3-pickup-card__fact--address';
    address.href = MAP_URL;
    address.target = '_blank';
    address.rel = 'noopener';
    address.setAttribute('aria-label', 'Ver ubicación de Libre Punto en Google Maps');
    address.innerHTML = `
      <span class="lp3-pickup-card__fact-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke-width="1.7"><path d="M12 21s7-5.3 7-12a7 7 0 1 0-14 0c0 6.7 7 12 7 12Z"/><circle cx="12" cy="9" r="2.4"/></svg>
      </span>
      <span><strong>Galería Madrid · Local 163</strong><small>Av. Pedro de Valdivia 1783, Providencia</small></span>
    `;
    facts.prepend(address);
  }

  function polishCart() {
    const recommendations = document.querySelector('[data-lp-recommendations]');
    if (recommendations) {
      const grid = recommendations.querySelector('.lp-cart-recommendations__grid') || recommendations.querySelector('[data-max-visible]');
      if (grid) {
        grid.dataset.maxVisible = '4';
        const cards = [...grid.querySelectorAll('.lp-rec-card')];
        cards.forEach((card, index) => {
          const hidden = index >= 4;
          card.classList.toggle('is-hidden', hidden);
          card.hidden = hidden;
          card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        });
      }

      if (!recommendations.querySelector('.lp-cart-secondary-actions')) {
        const actions = document.createElement('nav');
        actions.className = 'lp-cart-secondary-actions';
        actions.setAttribute('aria-label', 'Continuar comprando');
        actions.innerHTML = `
          <a class="lp-cart-secondary-actions__link" href="/collections/all">Seguir comprando</a>
          <a class="lp-cart-secondary-actions__link lp-cart-secondary-actions__link--primary" href="/collections/packs">Ver packs</a>
        `;
        const head = recommendations.querySelector('.lp-cart-recommendations__head');
        if (head) head.insertAdjacentElement('afterend', actions);
        else recommendations.prepend(actions);
      }
    }

    document.querySelectorAll('.lp-cart-delivery small').forEach((node) => {
      if (/Santiago Centro/i.test(node.textContent || '')) {
        node.textContent = 'Galería Madrid, Providencia';
      }
    });
  }

  function polishPackPage() {
    const summary = document.querySelector('.lp-pack-summary');
    if (!summary) return;
    document.body.classList.add('lp-pack-template');

    if (!document.querySelector('.lp-pack-context')) {
      const context = document.createElement('div');
      context.className = 'lp-pack-context';
      context.innerHTML = '<span>Pack seleccionado por Libre Punto</span><a href="/collections/packs">Ver todos los packs →</a>';
      summary.insertAdjacentElement('beforebegin', context);
    }
  }

  function init() {
    addHomeAddress();
    polishCart();
    polishPackPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => window.setTimeout(init, 0));
  document.addEventListener('lp:cart:updated', () => window.setTimeout(init, 40));
  window.addEventListener('pageshow', init);
})();
